/**
 * @generated SignedSource<<2f29d35cda0c44d8040411ccb53b3d71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompaniesContainerQuery$variables = {
  slug: string;
};
export type CompaniesContainerQuery$data = {
  readonly organizationBySlug: {
    readonly name: string;
    readonly id: string;
    readonly totalCompanies: {
      readonly totalCount: number;
    };
    readonly " $fragmentSpreads": FragmentRefs<"CompaniesTable_organization" | "OrganizationDashboard_organization">;
  } | null;
};
export type CompaniesContainerQuery = {
  variables: CompaniesContainerQuery$variables;
  response: CompaniesContainerQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "includeDeleted",
  "value": "NO"
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v6 = {
  "alias": "totalCompanies",
  "args": [
    (v4/*: any*/)
  ],
  "concreteType": "CompaniesConnection",
  "kind": "LinkedField",
  "name": "companies",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": "companies(includeDeleted:\"NO\")"
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v4/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "CREATED_AT_DESC"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "ReportMetricResult",
  "kind": "LinkedField",
  "name": "reportMetrics",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompaniesContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organizationBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v6/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CompaniesTable_organization"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OrganizationDashboard_organization"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompaniesContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organizationBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "CompaniesConnection",
            "kind": "LinkedField",
            "name": "companies",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompaniesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Company",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deletedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rowId",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "legalName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReportsConnection",
                        "kind": "LinkedField",
                        "name": "reports",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organization",
                        "kind": "LinkedField",
                        "name": "organization",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrganizationSubscriptionsConnection",
                            "kind": "LinkedField",
                            "name": "organizationSubscriptions",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrganizationSubscription",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "currentPeriodEnd",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BillingPlan",
                                    "kind": "LinkedField",
                                    "name": "billingPlan",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "slug",
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "companies(first:10,includeDeleted:\"NO\",orderBy:\"CREATED_AT_DESC\")"
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "filters": [
              "orderBy",
              "includeDeleted"
            ],
            "handle": "connection",
            "key": "CompaniesTable_companies",
            "kind": "LinkedHandle",
            "name": "companies"
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "390b70917319dcf0c850dc4613d98d0d",
    "id": null,
    "metadata": {},
    "name": "CompaniesContainerQuery",
    "operationKind": "query",
    "text": "query CompaniesContainerQuery(\n  $slug: String!\n) {\n  organizationBySlug(slug: $slug) {\n    name\n    id\n    totalCompanies: companies(includeDeleted: NO) {\n      totalCount\n    }\n    ...CompaniesTable_organization\n    ...OrganizationDashboard_organization\n  }\n}\n\nfragment CompaniesTableRow_company on Company {\n  id\n  rowId\n  name\n  legalName\n  createdAt\n  deletedAt\n  reports {\n    totalCount\n  }\n  reportMetrics {\n    name\n    value\n  }\n  organization {\n    organizationSubscriptions {\n      nodes {\n        currentPeriodEnd\n        billingPlan {\n          slug\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment CompaniesTable_organization on Organization {\n  companies(first: 10, orderBy: CREATED_AT_DESC, includeDeleted: NO) {\n    edges {\n      node {\n        id\n        deletedAt\n        ...CompaniesTableRow_company\n        ...CompanyContextMenu_company\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CompanyContextMenu_company on Company {\n  id\n  deletedAt\n}\n\nfragment OrganizationDashboard_organization on Organization {\n  reportMetrics {\n    name\n    value\n  }\n  totalCompanies: companies(includeDeleted: NO) {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "004abed694ebee6c72530c91be4e8c00";

export default node;
